export var INITIAL_PRODUCT_FORM = {
    IdSponsor: "",
    IdTypeInsurance: "",
    Description: "",
    Code: "",
    IdCurrency: "",
    CertifyNumber: "",
    QuotesNumber: 0,
    PolicyNumber: 0,
    isIframe: false,
    IframeUrl: "",
};
export var INITIAL_CAMPAIGN_FORM = {
    CampaignName: "",
    CodeCampaign: "",
    StartDateCampaign: "",
    EndDateCampaign: "",
};
